/* Mobile menu burger toggle */
(function () {
const navigation = document.querySelector('.gh-navigation');
if (!navigation) return;

const burger = navigation.querySelector('.gh-burger');
if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();


  window.portalConfig = {
    primarytier1: "{{@custom.homepage_tier_1}}",
  };

    const DEBUG = false;
    const testimonials = document.querySelectorAll('.testimonial');
    const dots = document.querySelectorAll('.dot');
    const dotsContainer = document.querySelector('.dots');
    let currentPeriod = 'monthly'; 
    const BASE_PLAN_SLUG = 'default-product';

  /* =========================
     VALIDATION
  ========================= */
  function validateFields() {

    const nameInput = document.getElementById('name');
    const emailInput = document.getElementById('email');
      
if (!nameInput || !emailInput) {
if (DEBUG)   console.warn("Inputs missing — skipping validation");
  return true;
}
    if (!nameInput.value.trim()) {
      nameInput.focus();
      return false;
    }

    if (!emailInput.checkValidity()) {
      emailInput.focus();
      return false;
    }

    return true;
  }
/* Fields Update for Members */

async function updateMemberProfile(name, email) {
  try {
    const res = await fetch('/members/api/member/', {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        members: [{
          name,
          email
        }]
      })
    });

    if (!res.ok) {
      const text = await res.text();
      console.error("Update failed:", text);
      return false;
    }

    console.log("Details updated");
    return true;

  } catch (err) {
    console.error("Update error:", err);
    return false;
  }
}
  /* =========================
     SIGNUP REDIRECT
  ========================= */
/* =========================
   SUBSCRIPTION ACTIONS
========================= */

function getCheckoutCadence(period) {
  return period === 'yearly' ? 'yearly' : 'monthly';
}

function getApiCadence(period) {
  return period === 'yearly' ? 'year' : 'month';
}

function goToSignup(tierId, period) {
  if (!tierId) return;

  const nameInput = document.getElementById('name');
  const emailInput = document.getElementById('email');

  const nameValue =
    nameInput?.value?.trim() ||
    window.currentMemberName ||
    '';

  const emailValue =
    emailInput?.value?.trim() ||
    window.currentMemberEmail ||
    '';

  if (!nameValue) {
    nameInput?.focus();
    return;
  }

  if (!emailValue) {
    emailInput?.focus();
    return;
  }

  const cadence = getCheckoutCadence(period);

  const url =
    `${window.location.origin}/#/portal/signup/` +
    `${encodeURIComponent(tierId)}/${cadence}` +
    `?name=${encodeURIComponent(nameValue)}` +
    `&email=${encodeURIComponent(emailValue)}`;

  window.location.assign(url);
}

async function updateExistingSubscription(tierId, period) {
  const subscriptionId =
    window.currentMemberSubscriptionId;

  if (!subscriptionId || !tierId) {
    throw new Error(
      'The current subscription could not be identified.'
    );
  }

  const sessionResponse = await fetch(
    '/members/api/session',
    {
      credentials: 'same-origin'
    }
  );

  if (!sessionResponse.ok) {
    throw new Error(
      'Your member session could not be verified.'
    );
  }

  const identity = await sessionResponse.text();

  if (!identity) {
    throw new Error(
      'Your member session has expired. Please sign in again.'
    );
  }

  const response = await fetch(
    `/members/api/subscriptions/` +
      `${encodeURIComponent(subscriptionId)}/`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        identity,
        tierId,
        cadence: getApiCadence(period),
        cancel_at_period_end: false
      })
    }
  );

  if (!response.ok) {
    let message =
      'Your subscription could not be updated.';

    try {
      const result = await response.json();

      message =
        result?.errors?.[0]?.message ||
        message;
    } catch {
      // Keep fallback message.
    }

    throw new Error(message);
  }

  return true;
}

async function chooseMembershipPlan(tierId, period) {
  const hasActivePaidSubscription =
    Boolean(window.currentMemberSubscriptionId);

  if (
    isManagePage &&
    hasActivePaidSubscription
  ) {
    return updateExistingSubscription(
      tierId,
      period
    );
  }

  goToSignup(tierId, period);
  return false;
}

if (testimonials.length <= 1 && dotsContainer) {
  dotsContainer.style.display = 'none';
}

/* =========================
   TESTIMONIAL SLIDER
   FIX: wrapped in its own IIFE so `sliderInterval` is scoped here and
   cannot be overwritten by the portal polling block that previously
   declared a global `interval` and stomped on this one, breaking clearInterval.
========================= */
(function () {
    let current = 0;
    let sliderInterval;
    let isPaused = false;

    function showSlide(index) {
        testimonials.forEach((el, i) => el.classList.toggle('active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
        current = index;
    }

    if (testimonials.length > 0) showSlide(0);

    function startSlider() {
        sliderInterval = setInterval(() => {
            if (!isPaused) showSlide((current + 1) % testimonials.length);
        }, 5000);
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => showSlide(i)));

    const sliderEl = document.querySelector('.testimonial-slider');
    if (sliderEl) {
        sliderEl.addEventListener('mouseenter', () => { isPaused = true; });
        sliderEl.addEventListener('mouseleave', () => { isPaused = false; });

        let startX = 0;
        sliderEl.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
        sliderEl.addEventListener('touchend', e => {
            const diff = startX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                showSlide(diff > 0
                    ? (current + 1) % testimonials.length
                    : (current - 1 + testimonials.length) % testimonials.length);
            }
        });
    }

    if (testimonials.length > 0) startSlider();
    dots.forEach((dot, i) => { if (!testimonials[i]) dot.style.display = "none"; });
})();

const isSignupPage = window.location.pathname.includes('/sign-up');
const isManagePage = window.location.pathname.includes('/manage-account');

document.addEventListener("DOMContentLoaded", function () {

if (isManagePage) {
  const nameInput = document.getElementById('name');
  const emailInput = document.getElementById('email');

  if (nameInput && emailInput) {
    const saveBtn = document.createElement('button');
    saveBtn.textContent = "Click here to update your account settings.";
    saveBtn.className = "card-btn";
    saveBtn.style.marginTop = "10px";

    emailInput.parentNode.appendChild(saveBtn);

saveBtn.addEventListener('click', () => {
  window.location.href = "#/portal/account";
});
      
  }
}    

/* =========================
   GROUP PLAN CARD NAVIGATION
========================= */

function openGroupPlanSection() {
  const groupSection =
    document.getElementById('group-plans');

  if (!groupSection) return;

  /*
   * On Manage Account, the selector is inside
   * the Manage Your Plan accordion.
   */
  if (isManagePage) {
    const managePlanAccordion =
      document.getElementById(
        'manage-plan-accordion'
      );

    if (managePlanAccordion) {
      document
        .querySelectorAll('.accordion-item')
        .forEach(item => {
          const shouldOpen =
            item === managePlanAccordion;

          item.classList.toggle(
            'active',
            shouldOpen
          );

          const header =
            item.querySelector(
              '.accordion-header'
            );

          if (header) {
            header.setAttribute(
              'aria-expanded',
              String(shouldOpen)
            );
          }
        });
    }
  }

  window.setTimeout(() => {
    groupSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, 100);
}


/*
 * Set the Group Membership card button text
 * according to the current page.
 */
document
  .querySelectorAll('.js-group-plan-btn')
  .forEach(button => {
    const text =
      button.querySelector('.btn-text') ||
      button;

    if (isSignupPage || isManagePage) {
      text.textContent =
        'SELECT TEAM SIZE BELOW >';

      button.setAttribute(
        'href',
        '#group-plans'
      );
    } else {
      text.textContent =
        'LEARN MORE >';
    }
  });


/*
 * On signup/manage-account, clicking the card
 * scrolls instead of navigating away.
 */
document.addEventListener(
  'click',
  function (event) {
    const button =
      event.target.closest(
        '.js-group-plan-btn'
      );

    if (!button) return;

    if (!isSignupPage && !isManagePage) {
      /*
       * Homepage: retain the HBS link to:
       * /sign-up/?plan=group#group-plans
       * or /manage-account/?plan=group#group-plans
       */
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    history.replaceState(
      null,
      '',
      `${window.location.pathname}` +
      `${window.location.search}` +
      '#group-plans'
    );

    openGroupPlanSection();
  }
);


/*
 * Handle arrival from the homepage.
 */
const groupPlanParameters =
  new URLSearchParams(
    window.location.search
  );

if (
  window.location.hash === '#group-plans' ||
  groupPlanParameters.get('plan') === 'group'
) {
  openGroupPlanSection();
}
  
/* ------------------ */
/* TITLE SPLIT */
/* ------------------ */
document.querySelectorAll('.tier-title').forEach(el => {
  if (el.dataset.split === "true") return;

  const text = el.textContent.trim(); // IMPORTANT: safe extraction
  const words = text.split(/\s+/);

  el.textContent = '';

  if (words.length > 1) {
    const first = document.createElement('span');
    first.className = 'word';
    first.textContent = words[0];

    const second = document.createElement('span');
    second.className = 'word';
    second.textContent = words.slice(1).join(' ');

    el.appendChild(first);
    el.appendChild(second);
  } else {
    const span = document.createElement('span');
    span.className = 'word';
    span.textContent = words[0];
    el.appendChild(span);
  }

  el.dataset.split = "true";
});
    
    /* FLIP CARDS */

    const cards = document.querySelectorAll('.flip-card');

if (cards.length > 0) {
  // flip click
  cards.forEach(card => {
    card.addEventListener('click', (e) => {

      if (
            e.target.closest(
              'a, button, input, select, textarea, label'
            )
          ) {
            return;
          }
      
      card.classList.toggle('active');
    });
  });

  // observer
  if (window.innerWidth <= 768) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.95) {
          entry.target.classList.add('active');
        } else {
          entry.target.classList.remove('active');
        }
      });
    }, { threshold: 0.95 });

    cards.forEach(card => observer.observe(card));
  }

  // height normalize
  function normalizeCardHeights() {
    let maxHeight = 0;

    cards.forEach(card => {
      const inner = card.querySelector('.flip-inner');
      inner.style.height = 'auto';
      card.querySelector('.flip-front').style.height = 'auto';
      card.querySelector('.flip-back').style.height = 'auto';
    });

    document.body.offsetHeight;

    cards.forEach(card => {
      const front = card.querySelector('.flip-front');
      const back = card.querySelector('.flip-back');
      const height = Math.max(front.scrollHeight, back.scrollHeight);
      maxHeight = Math.max(maxHeight, height);
    });

    cards.forEach(card => {
      const inner = card.querySelector('.flip-inner');
      inner.style.height = maxHeight + 'px';
      card.querySelector('.flip-front').style.height = maxHeight + 'px';
      card.querySelector('.flip-back').style.height = maxHeight + 'px';
    });
  }

  window.addEventListener('load', () => {
    normalizeCardHeights();
    setTimeout(normalizeCardHeights, 300);
    setTimeout(normalizeCardHeights, 800);
  });

  window.addEventListener('resize', normalizeCardHeights);
}

 if (DEBUG)  console.log("Signup script loaded");
/* =========================
   DELEGATED CLICK HANDLER
========================= */
document.addEventListener(
  'click',
  async function (event) {
    const button =
      event.target.closest('.js-plan-btn');

    if (!button) return;

    /*
     * On the homepage, retain the normal link to
     * the custom signup page.
     */
    if (!isSignupPage && !isManagePage) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const tierId = button.dataset.tierId;
    const tierSlug = button.dataset.tierSlug;

    if (!tierId) return;

    const memberLoggedIn =
      Boolean(window.currentMemberEmail);

    if (
      !memberLoggedIn &&
      !validateFields()
    ) {
      return;
    }

    if (
      memberLoggedIn &&
      tierSlug === currentSlug
    ) {
      return;
    }

    if (memberLoggedIn && isManagePage) {
      const confirmed = window.confirm(
        'Your subscription will be changed to the selected plan. Continue?'
      );

      if (!confirmed) return;
    }

    button.classList.add('loading');

    try {
      const updated =
        await chooseMembershipPlan(
          tierId,
          currentPeriod
        );

      if (updated) {
        window.alert(
          'Your subscription plan has been updated.'
        );

        window.location.reload();
      }
    } catch (error) {
      console.error(
        'Plan change failed:',
        error
      );

      window.alert(
        error instanceof Error
          ? error.message
          : 'The plan could not be changed.'
      );
    } finally {
      button.classList.remove('loading');
    }
  }
);

/* =========================
   BUTTON TEXT UPDATE
========================= */
const buttons = document.querySelectorAll('.js-plan-btn');
const currentSlug = window.currentMemberTierSlug || "";
const isMember = !!window.currentMemberEmail;
const isComplimentary = window.currentMemberStatus === "comped";

buttons.forEach(btn => {
  const slug = btn.dataset.tierSlug;
  const text = btn.querySelector('.btn-text') || btn;

  // HOMEPAGE
  if (!isSignupPage && !isManagePage) {
    text.textContent = "LEARN MORE >";
    return;
  }

  // SIGNUP (non-member)
  if (isSignupPage && !isMember) {
    text.textContent = "SUBSCRIBE >";
    return;
  }

  // MANAGE (member)
  if (isManagePage && isMember) {

    if (slug && slug === currentSlug) {
      text.textContent = "CURRENT PLAN";
      btn.style.pointerEvents = "none";
      btn.classList.add('disabled');
    } else {
      text.textContent = "CHOOSE THIS PLAN >";
    }

    return;
  }
});
                          
console.log("Page:", window.location.pathname);
console.log("isSignupPage:", isSignupPage);
console.log("isManagePage:", isManagePage);
console.log("isMember:", !!window.currentMemberEmail);
console.log("currentSlug:", currentSlug);

/* Hide the change link in account settings */
    
(function () {

  function injectStyles(doc) {
    if (doc.getElementById('hide-change-style')) return;

    const style = doc.createElement('style');
    style.id = 'hide-change-style';

    style.textContent = `
      button[data-test-button="change-plan"] {
        display: none !important;
      }
    `;

    doc.head.appendChild(style);
    console.log('✅ Injected hide-change CSS');
  }

  function watchIframe(iframe) {
    if (!iframe) return;

    iframe.addEventListener('load', () => {
      const doc = iframe.contentDocument;
      if (!doc) return;

      injectStyles(doc);
    });

    // also try immediately (for already-loaded case)
    const doc = iframe.contentDocument;
    if (doc) injectStyles(doc);
  }

  const observer = new MutationObserver(() => {
    const iframe = document.querySelector('iframe[data-testid="portal-popup-frame"]');
    if (iframe) {
      watchIframe(iframe);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
    
  /* =========================
     TOGGLE
  ========================= */
  document.querySelectorAll('.toggle-option').forEach(btn => {
    btn.addEventListener('click', function () {

      document.querySelectorAll('.toggle-option').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      currentPeriod = this.dataset.period;

      document.querySelectorAll('.price-monthly').forEach(el => {
        el.style.display = currentPeriod === 'monthly' ? 'inline' : 'none';
      });

      document.querySelectorAll('.price-yearly').forEach(el => {
        el.style.display = currentPeriod === 'yearly' ? 'inline' : 'none';
      });
      if (teamSlider) updateSlider(teamSlider.value);
    });
  });

/* =========================
   GROUP PLAN
========================= */

const tiers = Array.isArray(window.allTiers)
  ? window.allTiers
  : [];

const teamSlider =
  document.getElementById('teamSlider');

const teamCount =
  document.getElementById('teamCount');

const groupButton =
  document.getElementById('groupSignup');

const teamMinus =
  document.getElementById('teamMinus');

const teamPlus =
  document.getElementById('teamPlus');

const groupSection =
  document.getElementById('group-plans');

const totalPriceElement =
  groupSection?.querySelector('.total-price');

const perUserPriceElement =
  groupSection?.querySelector('.per-user-price');

const discountElement =
  groupSection?.querySelector('.discount');

const currentPriceElement =
  groupSection?.querySelector('.current-price');

const priceDifferenceElement =
  groupSection?.querySelector('.price-diff');


function getGroupSize(tier) {
  const source =
    `${tier?.slug || ''} ${tier?.name || ''}`;

  const match = source.match(/x\s*(\d+)/i);

  if (!match) return null;

  const size = Number(match[1]);

  return size >= 5 && size <= 20
    ? size
    : null;
}


const groupTiersBySize = new Map();

tiers.forEach(tier => {
  const size = getGroupSize(tier);

  if (size) {
    groupTiersBySize.set(size, tier);
  }
});


function getTierPrice(tier, period) {
  if (!tier) return null;

  const value =
    period === 'yearly'
      ? tier.yearly_price
      : tier.monthly_price;

  const amount = Number(value);

  return Number.isFinite(amount)
    ? amount / 100
    : null;
}


function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}


function getPeriodLabel(period) {
  return period === 'yearly'
    ? '/year'
    : '/month';
}


function getCurrentGroupSize() {
  const match =
    String(currentSlug).match(/x\s*(\d+)/i);

  return match ? Number(match[1]) : null;
}


const currentGroupSize =
  getCurrentGroupSize();

let selectedGroupTier = null;
let selectedGroupSize = null;


function updateGroupControls(size) {
  if (teamMinus) {
    teamMinus.disabled = size <= 5;
  }

  if (teamPlus) {
    teamPlus.disabled = size >= 20;
  }
}


function updateGroupMessage(size) {
  if (!groupSection) return;

  let messageElement =
    groupSection.querySelector('.group-message');

  if (!messageElement) {
    messageElement =
      document.createElement('div');

    messageElement.className =
      'group-message';

    groupSection
      .querySelector('.team-controls')
      ?.insertAdjacentElement(
        'afterend',
        messageElement
      );
  }

  const messages = [];

  if (isMember && !currentGroupSize) {
    messages.push(
      'You currently have an individual membership.'
    );
  }

  if (currentGroupSize) {
    messages.push(
      `Your current group plan includes ` +
      `${currentGroupSize} total users.`
    );
  }

  if (isComplimentary) {
    messages.push(
      'Changing to this plan will begin paid billing.'
    );
  }

  if (size === 20) {
    messages.push(
      'For more than 20 users, contact us for a customized plan.'
    );
  }

  messageElement.innerHTML = messages.length
    ? `<ul class="check-list-target-audience">` +
      messages
        .map(message => `<li>${message}</li>`)
        .join('') +
      `</ul>`
    : '';
}


function updateGroupPricing(size, tier) {
  const selectedTotal =
    getTierPrice(tier, currentPeriod);

  const individualTier =
    tiers.find(
      item => item.slug === BASE_PLAN_SLUG
    );

  const individualPrice =
    getTierPrice(
      individualTier,
      currentPeriod
    );

  if (
    selectedTotal === null ||
    individualPrice === null
  ) {
    if (totalPriceElement) {
      totalPriceElement.textContent =
        'Pricing is currently unavailable.';
    }

    return;
  }

  const currency =
    tier.currency ||
    individualTier?.currency ||
    'USD';

  const periodLabel =
    getPeriodLabel(currentPeriod);

  const perUser =
    selectedTotal / size;

  if (totalPriceElement) {
    totalPriceElement.textContent =
      `Total: ` +
      `${formatCurrency(
        selectedTotal,
        currency
      )}${periodLabel}`;
  }

  if (perUserPriceElement) {
    perUserPriceElement.textContent =
      `Per user: ` +
      `${formatCurrency(
        perUser,
        currency
      )}${periodLabel}`;
  }

  const fullIndividualCost =
    individualPrice * size;

  const savings =
    fullIndividualCost - selectedTotal;

  const savingsPercent =
    fullIndividualCost > 0
      ? Math.round(
          savings /
          fullIndividualCost *
          100
        )
      : 0;

  if (discountElement) {
    discountElement.textContent =
      savings > 0
        ? `Group saving: ` +
          `${formatCurrency(
            savings,
            currency
          )}${periodLabel} ` +
          `(${savingsPercent}%)`
        : '';
  }

  /*
   * Current-plan comparison on Manage Account.
   */
  if (currentPriceElement) {
    if (isComplimentary) {
      currentPriceElement.textContent =
        'Current plan: Complimentary';
    } else if (currentSlug) {
      const currentTier =
        tiers.find(
          item => item.slug === currentSlug
        );

      const currentPeriodForPrice =
        window.currentMemberBillingPeriod ===
          'year'
          ? 'yearly'
          : 'monthly';

      const currentTotal =
        getTierPrice(
          currentTier,
          currentPeriodForPrice
        );

      if (currentTotal !== null) {
        currentPriceElement.textContent =
          `Current catalogue price: ` +
          `${formatCurrency(
            currentTotal,
            currentTier?.currency ||
              currency
          )}` +
          `${getPeriodLabel(
            currentPeriodForPrice
          )}`;
      }
    }
  }

  if (priceDifferenceElement) {
    const currentTier =
      tiers.find(
        item => item.slug === currentSlug
      );

    const actualCurrentPeriod =
      window.currentMemberBillingPeriod ===
        'year'
        ? 'yearly'
        : 'monthly';

    const currentTotal =
      getTierPrice(
        currentTier,
        actualCurrentPeriod
      );

    if (
      currentTotal !== null &&
      actualCurrentPeriod === currentPeriod
    ) {
      const difference =
        selectedTotal - currentTotal;

      priceDifferenceElement.textContent =
        difference === 0
          ? 'No catalogue-price difference.'
          : `Catalogue-price difference: ` +
            `${difference > 0 ? '+' : '−'}` +
            `${formatCurrency(
              Math.abs(difference),
              currency
            )}${periodLabel}`;
    } else if (
      currentSlug &&
      actualCurrentPeriod !== currentPeriod
    ) {
      priceDifferenceElement.textContent =
        'The billing frequency will also change. ' +
        'The final prorated amount is calculated by Ghost and Stripe.';
    } else {
      priceDifferenceElement.textContent = '';
    }
  }
}


function updateGroupButton(size, tier) {
  if (!groupButton || !tier) return;

  selectedGroupSize = size;
  selectedGroupTier = tier;

  const isCurrentGroupPlan =
    Boolean(window.currentMemberSubscriptionId) &&
    currentGroupSize === size &&
    (
      window.currentMemberBillingPeriod ===
        'year'
        ? 'yearly'
        : 'monthly'
    ) === currentPeriod;

  groupButton.classList.toggle(
    'disabled',
    isCurrentGroupPlan
  );

  groupButton.setAttribute(
    'aria-disabled',
    String(isCurrentGroupPlan)
  );

  if (isCurrentGroupPlan) {
    groupButton.textContent =
      'Your Current Group Plan';
  } else if (
    window.currentMemberSubscriptionId
  ) {
    groupButton.textContent =
      currentGroupSize
        ? 'Change Group Plan'
        : 'Switch to Group Plan';
  } else {
    groupButton.textContent =
      'Get Group Plan';
  }
}


function updateSlider(value) {
  const size = Number(value);

  if (!Number.isInteger(size)) return;

  if (teamCount) {
    teamCount.textContent =
      String(size);
  }

  const tier =
    groupTiersBySize.get(size);

  updateGroupControls(size);
  updateGroupMessage(size);

  if (!tier) {
    selectedGroupTier = null;

    if (totalPriceElement) {
      totalPriceElement.textContent =
        `No Ghost tier was found for x${size}.`;
    }

    if (groupButton) {
      groupButton.textContent =
        'Plan Unavailable';

      groupButton.classList.add(
        'disabled'
      );

      groupButton.setAttribute(
        'aria-disabled',
        'true'
      );
    }

    return;
  }

  updateGroupPricing(size, tier);
  updateGroupButton(size, tier);
}


if (teamSlider) {
  const initialSize =
    currentGroupSize ||
    Number(teamSlider.value) ||
    5;

  teamSlider.value =
    String(initialSize);

  updateSlider(initialSize);

  teamSlider.addEventListener(
    'input',
    event => {
      updateSlider(event.target.value);
    }
  );
}


teamMinus?.addEventListener(
  'click',
  function () {
    if (!teamSlider) return;

    const value =
      Number(teamSlider.value);

    if (value > 5) {
      teamSlider.value =
        String(value - 1);

      updateSlider(teamSlider.value);
    }
  }
);


teamPlus?.addEventListener(
  'click',
  function () {
    if (!teamSlider) return;

    const value =
      Number(teamSlider.value);

    if (value < 20) {
      teamSlider.value =
        String(value + 1);

      updateSlider(teamSlider.value);
    }
  }
);


groupButton?.addEventListener(
  'click',
  async function (event) {
    event.preventDefault();

    if (
      groupButton.getAttribute(
        'aria-disabled'
      ) === 'true'
    ) {
      return;
    }

    if (!selectedGroupTier) {
      return;
    }

    if (
      !isMember &&
      !validateFields()
    ) {
      return;
    }

    if (isMember && isManagePage) {
      const confirmed = window.confirm(
        `Change your subscription to the ` +
        `${selectedGroupSize}-user plan?`
      );

      if (!confirmed) return;
    }

    groupButton.classList.add('loading');

    try {
      const updated =
        await chooseMembershipPlan(
          selectedGroupTier.id,
          currentPeriod
        );

      if (updated) {
        window.alert(
          'Your subscription plan has been updated.'
        );

        window.location.reload();
      }
    } catch (error) {
      console.error(
        'Group plan change failed:',
        error
      );

      window.alert(
        error instanceof Error
          ? error.message
          : 'The group plan could not be selected.'
      );
    } finally {
      groupButton.classList.remove(
        'loading'
      );
    }
  }
);

/* =====================
LIST STYLING FOR TARGET AUDIENCE
====================== */
  document.querySelectorAll('.check-list-target-audience[data-static="true"]').forEach(el => {

  if (el.querySelector('li')) return;

    let raw = el.textContent.trim();

    if (!raw) {
      console.warn("Empty list:", el);
      return;
    }

    // 🔥 remove surrounding quotes if present
    raw = raw.replace(/^["']|["']$/g, '');

    const items = raw
      .split(',')
      .map(i => i.trim())
      .filter(Boolean);

    if (!items.length) return;

    el.innerHTML = items.map(item => `<li>${item}</li>`).join('');
  });
 });

/* =====================
REDIRECT FUNCTIONS
====================== */

(function () {
  const path = window.location.pathname;
  const hash = window.location.hash;

  if (
    (path === '/signup/' ||
    hash === '#/portal/signup' ||
    hash === '#/portal/signup/') &&
    path !== '/sign-up-modal/'
  ) {
    window.location.href = '/sign-up/';
  }
})();

async function isMember() {
  try {
    const response = await fetch('/members/api/member/');
    return response.status === 200;
  } catch {
    return false;
  }
}

/* =====================
SIGN UP FUNCTIONS
====================== */

(function () {
  const SIGNUP_URL = '/sign-up/';

  function redirectToCustomSignup(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    window.location.href = SIGNUP_URL;
  }

  function replacePortalSignupButton() {
    const signupMessages = document.querySelectorAll('.gh-portal-signup-message');

    signupMessages.forEach((message) => {
      if (message.dataset.customSignupApplied === 'true') return;

      const nativeButton = message.querySelector(
        'button[data-test-button="signup-switch"], button.gh-portal-btn-link'
      );

      if (!nativeButton) return;

      message.dataset.customSignupApplied = 'true';

      message.innerHTML = `
        <div>Don't have an account?</div>
        <a href="${SIGNUP_URL}" class="gh-portal-btn gh-portal-btn-link custom-signup-link">
          <span>View subscription options</span>
        </a>
      `;
    });
  }

  function interceptPortalSignupClicks() {
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target.closest(
          'a[href="#/portal/signup"], a[href="/#/portal/signup"], button[data-test-button="signup-switch"]'
        );

        if (!target) return;

        redirectToCustomSignup(event);
      },
      true
    );
  }

  function redirectDirectPortalSignupHash() {
    if (window.location.hash === '#/portal/signup') {
      window.location.href = SIGNUP_URL;
    }
  }

  redirectDirectPortalSignupHash();
  interceptPortalSignupClicks();

  const observer = new MutationObserver(function () {
    replacePortalSignupButton();
    redirectDirectPortalSignupHash();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('DOMContentLoaded', replacePortalSignupButton);
  window.addEventListener('hashchange', redirectDirectPortalSignupHash);
})();